__turbopack_context__.v({
  "defaultHeroContentStack": "hero-intro-shared-module-scss-module__sEwpza__defaultHeroContentStack",
  "defaultHeroContentStackEditing": "hero-intro-shared-module-scss-module__sEwpza__defaultHeroContentStackEditing",
  "heroContentIn": "hero-intro-shared-module-scss-module__sEwpza__heroContentIn",
  "heroContentSection": "hero-intro-shared-module-scss-module__sEwpza__heroContentSection",
  "heroContentStack": "hero-intro-shared-module-scss-module__sEwpza__heroContentStack",
  "heroDescription": "hero-intro-shared-module-scss-module__sEwpza__heroDescription",
  "heroImage": "hero-intro-shared-module-scss-module__sEwpza__heroImage",
  "heroImageIn": "hero-intro-shared-module-scss-module__sEwpza__heroImageIn",
  "heroImageScrim": "hero-intro-shared-module-scss-module__sEwpza__heroImageScrim",
  "heroLink": "hero-intro-shared-module-scss-module__sEwpza__heroLink",
  "heroLinks": "hero-intro-shared-module-scss-module__sEwpza__heroLinks",
  "heroScrollable": "hero-intro-shared-module-scss-module__sEwpza__heroScrollable",
  "heroTitle": "hero-intro-shared-module-scss-module__sEwpza__heroTitle",
});
